import React, { Component } from 'react';
import SignUpForm from './signUpForm';
import Fade from 'react-reveal/Fade';

// Images
import Logo from './icons/Logo';

class SignUp extends Component {
  render() {
    return (
      <div className="signUp">

        <Fade bottom>
        <div className="wrap">

          <span>Sign up for Early Access Beta Testing</span>
          <Logo />

          <SignUpForm />

        </div>
        </Fade>

      </div>
    );
  }
}

export default SignUp;



// WEBPACK FOOTER //
// ./src/assets/components/signUp.js